import { useGlobalSearchParams, useNavigation } from 'expo-router';
import { useEffect } from 'react';
import { Platform, StyleSheet } from 'react-native';
import Animated, { useAnimatedRef } from 'react-native-reanimated';

import { useGetNonProfitInsights } from '@/api/hooks/nonProfitOrgHooks';
import DotsLoader from '@/components/DotsLoader';
import { useScrollProps } from '@/components/navigation/TopTabsReanimated';
import InsightsComponent from '@/components/npo/details/insights/InsightsComponent';

const NPOInsightsScreen = () => {
  const { npoId } = useGlobalSearchParams<{
    npoId: string;
  }>();

  const { scrollEnabled, scrollTopHeader, scrollHandler } = useScrollProps();

  const animatedRef = useAnimatedRef<Animated.ScrollView>();
  const navigation = useNavigation<any>();

  const { data, isPending, isLoading } = useGetNonProfitInsights({ id: npoId });

  useEffect(() => {
    const unsubscribe = navigation.addListener('tabPress', () => {
      scrollTopHeader();
      animatedRef.current?.scrollTo({
        y: 0,
        animated: false
      });
    });

    return unsubscribe;
  }, [animatedRef, navigation, scrollTopHeader]);

  if (isPending || isLoading) return <DotsLoader />;

  return (
    <Animated.ScrollView
      ref={animatedRef}
      onScroll={scrollHandler}
      scrollEnabled={scrollEnabled}
      showsVerticalScrollIndicator={false}
      bounces={false}
      style={styles.scrollViewContainer}>
      <InsightsComponent canEdit={false} data={data} />
    </Animated.ScrollView>
  );
};

export default NPOInsightsScreen;

const styles = StyleSheet.create({
  scrollViewContainer: {
    paddingHorizontal: Platform.OS !== 'web' ? 18 : 0
  }
});
